import { render, staticRenderFns } from "./StatsRating.vue?vue&type=template&id=38cbf18a&"
import script from "./StatsRating.vue?vue&type=script&lang=js&"
export * from "./StatsRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports